import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-list-two',
  templateUrl: './shop-list-two.component.html',
  styleUrls: ['./shop-list-two.component.scss']
})
export class ShopListTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
